<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent>
        <baseMessage :disabled="true" view @getDetail="getDetail"/>
        <dc-layout-card title="评论记录" :isAutoLayout="false">
      <span v-if="detail.score > 0">
              <a-rate style="margin-bottom: 16px;margin-top: -10px;" v-model:value="detail.score"
                      :tooltips="commentDesc" :disabled="true"/>
              <span class="ant-rate-text">{{ commentDesc[detail.score - 1] }}</span>
            </span>
          <commentList
            ref="commentListRef"
            :permissionPage="{
            delComment: type === 'view' ? 'lbu_accompanying_visit_del_comment' : 'lbu_accompanying_visit_del_comment'
          }"
            :data="detail.commentList"
            :id="route.query.id"
          />
        </dc-layout-card>
        <a-form name="detailsForm" ref="formRef" :model="form" v-if="commentComputed">
          <dc-layout-card title="评论">
            <span v-if="detail.score <= 0">
              <a-rate style="margin-left: 20px;margin-bottom: 16px;margin-top: -10px;" v-model:value="form.score"
                      :tooltips="commentDesc" :disabled="detail.score > 0"/>
              <span class="ant-rate-text">{{ commentDesc[form.score - 1] }}</span>
            </span>
            <a-col :span="24">
              <Editor
                v-model:value="form.content"
                :maxlength="3000"
                v-model:mention="form.userCodes"
                placeholder="请输入评论"
              />
            </a-col>
            <dc-form-item label="上传附件" name="fileId" :span="24">
              <UploadFile v-model:value="form.fileId" valueType="array"/>
            </dc-form-item>
          </dc-layout-card>
        </a-form>
      </CosViewContent>
      <cos-footer-button :loading="loading" hideOk>
        <a-button
          v-show="commentComputed && activeKey === 'base'"
          type="primary"
          @click="handleCommit"
          :loading="loading"
          v-permission="'lbu_accompanying_visit_comment_btn'"
        >发表
        </a-button
        >
        <a-button type="primary" v-if="props.type === 'add' || props.type === 'edit'" @click="handleSubmit()"
                  :loading="loading"
        >保存
        </a-button
        >
        <a-button
          type="primary"
          v-if="props.type === 'view'"
          @click="editRow"
          v-permission="'lbu_accompanying_visit_edit_btn'"
        >
          编辑
        </a-button>
        <a-button
          v-if="props.type === 'view'"
          v-permission="'lbu_accompanying_visit_comment_btn'"
          @click="commentRow"
        >
          评论
        </a-button>
      </cos-footer-button>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { computed, ref } from 'vue'
import baseMessage from '../components/baseMessage.vue'
import commentList from '../components/commentList.vue'
import Editor from '@/components/Editor'
import UploadFile from '@/components/UploadFile'
import { DcMessage } from '@dc-platform/dc-components'
import { useRoute, useRouter } from 'vue-router'
import { layoutTags } from '@dc-platform/dc-interaction'
import { AccompanyingVisitComment, AccompanyingVisitDetail } from '@/typings/api/yuntuSales'
import {
  accompanyingVisitComment,
  accompanyingVisitCreate,
  accompanyingVisitUpdate
} from '@/api/yuntuSales/superivisorAccompanyingVisit'
import { goBack } from '@/hooks/cosRouter'
import { FormInstance } from 'ant-design-vue'

const router = useRouter()
const route = useRoute()
const form = ref<AccompanyingVisitComment>({
  fileId: []
})
const detail = ref<AccompanyingVisitDetail>({})

const commentDesc = ref<string[]>(['非常不满意', '不满意', '一般', '满意', '非常满意'])

const props = defineProps({
  type: {
    default: String
  }
})
const activeKey = ref('base')
const loading = ref(false)
const commentListRef = ref()
const formRef = ref<FormInstance>()
const showComment = ref(false)
const commentComputed = computed(() => {
  if (props.type === 'comment') {
    return true
  }
  return showComment.value
})
const editRow = () => {
  router.push({
    path: '/lbu/supervisorAccompanyingVisit/edit',
    query: {
      id: route.query.id
    }
  })
}
// 评论
const commentRow = () => {
  router.push({
    path: '/lbu/supervisorAccompanyingVisit/comment',
    query: {
      id: route.query.id
    }
  })
}
const handleSubmit = async () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = {
      ...detail.value
    }
    try {
      if (props.type === 'edit') {
        await accompanyingVisitUpdate(p)
        DcMessage.success('编辑成功')
      } else if (props.type === 'add') {
        await accompanyingVisitCreate(p)
        DcMessage.success('新增成功')
      }
      goBack()
    } catch (error) {
    }
    loading.value = false
  })
}
const handleCommit = () => {
  if (!form.value.content) {
    DcMessage.warning('请输入评论内容')
    return
  }
  loading.value = true
  // 评论必填
  accompanyingVisitComment(form.value)
    .then((res) => {
      DcMessage.success('发表成功')
      layoutTags.close()
    })
    .finally(() => {
      loading.value = false
    })
}
const getDetail = (data: AccompanyingVisitDetail) => {
  detail.value = data
  form.value.accompanyId = data.id
  form.value.score = data.score
}
</script>
<script lang="ts">
export default {
  name: 'DcCosLbuSupervisorAccompanyingVisitComment'
}
</script>
